import React from "react";
import { Modal, Icon, Button } from "semantic-ui-react";

function WarningPopup({ warningMsgArr, open, onClose, onCancel, onOk }) {
  return (
    <Modal onClose={onClose} size="tiny" open={open}>
      <Modal.Content className="center-text">
        <Icon name="warning sign" size="huge" />
        <br />
        {warningMsgArr && warningMsgArr.map(e => <p>{e}</p>)}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel} inverted primary>
          No, Cancel.
        </Button>
        <Button onClick={onOk} primary>
          Yes I am sure.
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default WarningPopup;
